

export const routerUAVFlyManagePC = {
  path: "/UAVFlyManage",
  name: "UAVFlyManageHome",
  component: () => import("@/viewsUAVFlyManage/home.vue"),
  children: [
    {
      // 共青城市 模拟无人机飞行数据可视化
      path: "index_page",
      name: "fly_manage_index_page",
      component: () => import("@/viewsUAVFlyManage/indexPage"),
      meta: { name: "飞行器管理", keepAlive: true }
    },
    {
      // 航海 船员落水 数据可视化
      path: "navigation_page",
      name: "navigation_page",
      component: () => import("@/viewsUAVFlyManage/navigationPage"),
      meta: { name: "航海综合服务", keepAlive: true }
    }

  ]

}



// WEBPACK FOOTER //
// ./src/router/routerUAVFlyManage.js